/*
 * Show/hide button on password fields (input-text.twig, revealToggle: true)
 */
document.addEventListener('click', function(e) {
	const button = e.target.closest('[data-password-toggle]');
	if (!button) {
		return;
	}

	const input = document.getElementById(button.getAttribute('aria-controls'));
	if (!input) {
		return;
	}

	const show = input.type === 'password';
	input.type = show ? 'text' : 'password';
	button.setAttribute('aria-pressed', show ? 'true' : 'false');
	button.setAttribute('aria-label', show ? 'Hide password' : 'Show password');
	button.querySelector('[data-password-toggle-show]').classList.toggle('hidden', show);
	button.querySelector('[data-password-toggle-hide]').classList.toggle('hidden', !show);
});

// Never submit a revealed password as text the browser might remember
document.addEventListener('submit', function(e) {
	e.target.querySelectorAll('[data-password-toggle][aria-pressed="true"]').forEach(function(button) {
		const input = document.getElementById(button.getAttribute('aria-controls'));
		if (input) {
			input.type = 'password';
		}
	});
}, true);
